import { Pipe, PipeTransform } from '@angular/core';
import { Skill } from '@lib/shared-interface-skill';
import { Uuid } from '@lib/shared-interface-utility-types';

@Pipe({
    standalone: true,
    name: 'libSkillGroupKeysFromSkills',
})
export class SkillGroupKeysFromSkillsPipe implements PipeTransform {
    public transform(skills: Skill[] | undefined): Uuid[] {
        if (!skills) return [];
        const uniqueIds: Set<Uuid> = new Set();
        for (const skill of skills) {
            uniqueIds.add(skill.groupId);
        }
        return [...uniqueIds];
    }
}
